"use client";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dynamic from "next/dynamic";
const LoginFlow = dynamic(() => import("@/components/login-flow/index"));
const FloatingInput = dynamic(() =>
  import("@/components/floating-input/index")
);
const FormFilledError = dynamic(() => import("@/components/form-filled-error"));

// import LoginFlow from "@/components/login-flow/index";
// import FloatingInput from "@/components/floating-input/index";
// import FormFilledError from "@/components/form-filled-error";
import { useRouter } from "next/navigation";
// import Link from "next/link";
import { Button, Spinner, Toast, ToastContainer } from "react-bootstrap";
// import { Facebook, Google } from "@/components/icons/loginflow-icon/index";
import { sendOtp } from "@/redux/slices/authSlice";
import { ToastContext } from "@/contexts/ToastContext";
import CommonBtn from "@/components/buttons/CommonBtn";

export default function Login() {
  const router = useRouter();
  const dispatch = useDispatch();
  const { loading, data } = useSelector((state) => state.auth);
  const { showToast } = useContext(ToastContext);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [validationError, setValidationError] = useState("");

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
    setValidationError("");
  };

  const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberRegex = /^\d{10}$/;

    return phoneNumberRegex.test(phoneNumber);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      setValidationError("Mobile number is required.");
      return;
    }

    if (!validatePhoneNumber(phoneNumber)) {
      setValidationError(
        "Invalid phone number format. Please enter a valid 10-digit number."
      );
      return;
    }

    const payload = { phoneNumber };
    dispatch(sendOtp(payload))
      .unwrap()
      .then((resp) => {
        if (resp && resp.data) {
          // if (!resp.data.userExists) {
          //   setMessage(resp.message);
          //   setShowSuccessToast(true);
          //   setTimeout(() => {
          //     router.push("/register");
          //   }, 2000);
          //   return;
          // }

          if (resp?.data?.userExists) {
            showToast({ type: "success", message: resp.message });
          }
          localStorage.setItem("loginPhoneNumber", phoneNumber);

          setTimeout(() => {
            router.push(`/verification`);
          }, 2000);
        } else {
          showToast({ type: "error", message: "Failed to send OTP" });
        }
      })
      .catch((error) => {
        // setMessage(error.message);
        // setShowErrorToast(true);
        showToast({ type: "error", message: error.message });
      });
  };

  useEffect(() => {
    setValidationError("");
  }, []);

  return (
    <>
      <LoginFlow
        title="Login"
        subText="Log in to continue in our website"
        stepContent={
          <form
            onSubmit={handleLogin}
            className="grid  row-gap-3 row-gap-sm-4 column-gap-0"
          >
            <div className="g-col-12">
              <FloatingInput
                type="number"
                label="Mobile No"
                size="small"
                placeholder="Enter mobile no"
                controlId="floatingInput"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                // className={validationError ? "floating-input-error" : ""}
              />
              {validationError && <FormFilledError title={validationError} />}
            </div>
            <div className="g-col-12 mt-1">
              <CommonBtn
                className="w-100 rounded-1"
                variant="login-flow"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Continue"
                )}
              </CommonBtn>
              {/* <Button
                variant="link"
                className="text-white text-decoration-none w-100 rounded-1 loginflow-btn"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Continue"
                )}
              </Button> */}
            </div>
            <div className="g-col-12 text-center loginlast-content">
              {/* <p className="text-capitalize">Or Login With</p>
            <div className="d-flex align-items-center justify-content-center mt-3 icon-container">
              <span className="rounded-circle d-flex align-items-center justify-content-center cursor-pointer blue-icon-bg">
                <Facebook />
              </span>
              <span className="rounded-circle d-flex align-items-center justify-content-center cursor-pointer red-icon-bg">
                <Google />
              </span>
            </div> */}
              {/* <p className=" mt-1">
                Don&apos;t have an account?{" "}
                <Link href="/register">Register</Link>
              </p> */}
            </div>
          </form>
        }
      />
    </>
  );
}
